import React, {useEffect} from 'react';
import {useNavigate} from './routerCompat';

export const APP_NAVIGATION_EVENT = 'mediagraph:navigate';

export const activityActionHref = (actionPath, organizationSlug) => {
    if (!actionPath) return null;
    if (window.customDomainOrganizationSlug) return actionPath;
    return organizationSlug ? `/${organizationSlug}${actionPath}` : null;
};

export const requestAppNavigation = (event, to) => {
    if (!to || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    if (event.currentTarget?.target && event.currentTarget.target !== '_self') return;

    const navigationEvent = new CustomEvent(APP_NAVIGATION_EVENT, {
        cancelable: true,
        detail: {to},
    });
    const handled = !window.dispatchEvent(navigationEvent);
    if (handled) event.preventDefault();
};

export const AppNavigationBridge = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const handleNavigation = event => {
            if (typeof event.detail?.to !== 'string' || !event.detail.to) return;
            event.preventDefault();
            navigate(event.detail.to);
        };
        window.addEventListener(APP_NAVIGATION_EVENT, handleNavigation);
        return () => window.removeEventListener(APP_NAVIGATION_EVENT, handleNavigation);
    }, [navigate]);

    return null;
};
